import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDuj7cMBX9MMZqtu7aPtjJ2M6wrFZOl7oA",
  authDomain: "moodtunes-423d2.firebaseapp.com",
  projectId: "moodtunes-423d2",
  storageBucket: "moodtunes-423d2.firebasestorage.app",
  messagingSenderId: "41638311244",
  appId: "1:41638311244:web:a47ef58d02f8c938cf8be9",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
